import { useRef, useCallback, type ReactNode, type MouseEvent } from "react";

interface TiltCardProps {
  children: ReactNode;
  className?: string;
  degrees?: number;
}

export default function TiltCard({ children, className = "", degrees = 0.3 }: TiltCardProps) {
  const ref = useRef<HTMLDivElement>(null);

  const handleMouseMove = useCallback((e: MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width; // 0 = left, 1 = right
    // Right side → negative rotation (CCW), left side → positive (CW)
    const rotation = (x - 0.5) * -2 * degrees;
    el.style.transform = `translateY(-2px) rotate(${rotation}deg)`;
  }, [degrees]);

  const handleMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = "";
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
}
